module.exports = __webpack_public_path__ + "static/img/home1.1868c7ab.png";